export default class CDSPublication {

    constructor() {
        this.id = '';
        this.name = '';
        this.recursive = false;
    }

}
